import {
  Box,
  Divider,
  Drawer,
  Fab,
  List,
  ListItemButton,
  Stack,
  Typography,
} from '@mui/material'
import { useCallback, useMemo, useState } from 'react'
import { Icons } from 'utoniq-ui'

import { styles } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

type CreatePreSaleActionSheetCellProps = {
  isShow: boolean
}
export const CreatePreSaleActionSheetCell: Cell<CreatePreSaleActionSheetCellProps> =
  ({ isShow }) => {
    const [open, setOpen] = useState<boolean>(false)
    const { t } = useTranslation('consoleEventDetail')
    const { router, generatePath, routerPages } =
      useRouter<{ eventId: string }>()
    const toggleDrawer = useCallback(
      (open: boolean) => () => {
        setOpen(open)
      },
      []
    )
    const handleClose = () => setOpen(false)

    const items = useMemo(
      () => [
        {
          text: t('lotteryTicket'),
          href: generatePath(routerPages.ConsolePreSaleCreate, {
            preSaleType: 'lottery',
            eventId: router.query.eventId ?? '#',
          }),
        },
        {
          text: t('firstComeFirstServedTicket'),
          href: generatePath(routerPages.ConsolePreSaleCreate, {
            preSaleType: 'firstComeFirstServed',
            eventId: router.query.eventId ?? '#',
          }),
        },
      ],
      [t, generatePath, routerPages]
    )

    if (!isShow) return null

    return (
      <>
        <Stack direction="row-reverse">
          <Stack
            sx={{
              position: 'fixed',
              bottom: 16,
              zIndex: 5,
              maxWidth: 600,
              margin: '0 auto',
              px: 4,
              pb: styles.safeAreaBottom,
            }}
          >
            <Fab size="medium" color="primary" onClick={toggleDrawer(true)}>
              <Icons.ThinPlus fontSize="medium" sx={{ color: 'white' }} />
            </Fab>
          </Stack>
        </Stack>
        <Drawer open={open} onClose={handleClose}>
          <Box sx={{ p: 5 }}>
            <Typography variant="h6" color="grey.600" align="center">
              {t('selectPreSlaeType')}
            </Typography>
          </Box>
          <Divider />
          <List>
            {items.map(({ text, href }, index) => (
              <ListItemButton
                key={index}
                component={Stack}
                sx={{ height: 52 }}
                spacing={3}
                direction="row"
                onClick={() => router.push(href)}
              >
                <Typography variant="h6">{text}</Typography>
              </ListItemButton>
            ))}
            <Divider />
            <ListItemButton
              component={Box}
              sx={{ height: 52 }}
              alignItems="center"
              onClick={handleClose}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ width: '100%', color: 'primary.main' }}
              >
                {t('cancel')}
              </Typography>
            </ListItemButton>
          </List>
        </Drawer>
      </>
    )
  }
